import * as React from 'react';
import * as styles from './styles.css';

import { Header3, Paragraph1 } from '@cian/ui-kit';

export interface IPriceEstimationProps {
  description: string;
  priceRangeText: string;
  priceText: string;
  title: string;
}

export const PriceEstimation: React.FC<IPriceEstimationProps> = props => {
  return (
    <div className={styles['container']} data-testid="price-estimation">
      <div className={styles['item']}>
        <div className={styles['title']}>
          <Header3>{props.title}</Header3>
        </div>
        <Paragraph1 color="black_60">{props.description}</Paragraph1>
      </div>

      <div className={styles['item']}>
        <div className={styles['title']}>
          <Header3>{props.priceText}</Header3>
        </div>
        <Paragraph1 color="black_60">Рыночная цена этой квартиры</Paragraph1>
      </div>

      <div className={styles['item']}>
        <div className={styles['title']}>
          <Header3>{props.priceRangeText}</Header3>
        </div>
        <Paragraph1 color="black_60">Диапазон цены</Paragraph1>
      </div>
    </div>
  );
};

PriceEstimation.displayName = 'PriceEstimation';
